<div class="p-4 lg:p-10 flex-1 flex flex-col">
  <div class="flex items-center justify-end gap-6"></div>
  <div class="welcome flex flex-col gap-6 py-6">
    <div class="font-efSans-secondary font-semibold uppercase">
      {{ 'customer-portal' | sharedTranslate }}
    </div>
    <div class="font-canelablack-primary text-4xl md:text-5xl">
      {{ 'e-mail-confirmed' | sharedTranslate }}
    </div>
    <div
      class="text-mat-ef-revolution-primary-500 font-efSans text-xl font-light"
    >
      <T
        str="Are you already a Emil Frey customer?"
        key="customerPortal.kc.choose-existing.text"
        tags="kc-forms, 3.1"
      ></T>
    </div>
  </div>

  <form
    class="flex flex-col gap-3 relative"
    #chooseExistingForm
    [action]="viewData.registrationAction"
    method="POST"
    [formGroup]="form"
  >
    <mat-radio-group
      class="grid grid-cols-1 md:grid-cols-2 gap-6 items-center"
      formControlName="type"
      required
    >
      <div
        class="border rounded-lg p-6 grid gap-4 min-h-[140px] max-h-[140px]"
        [ngClass]="{
          'bg-mat-ef-revolution-supergrey-500': background === 'new'
        }"
      >
        <mat-radio-button
          data-cy="registration-new-existing-customer-radio-button"
          #new
          value="new"
          [disableRipple]="true"
          (click)="
            form.patchValue({ type: 'new' }); changeBackground(new.value)
          "
        >
          <div class="font-efSans-primary font-semibold">
            <T
              str="New customer"
              key="customerPortal.kc.choose-existing.type.new"
              tags="kc-forms, 3.1"
            ></T>
          </div>
        </mat-radio-button>
      </div>
      <div
        class="border rounded-lg p-6 grid gap-4 min-h-[140px] max-h-[140px]"
        [ngClass]="{
          'bg-mat-ef-revolution-supergrey-500': background === 'existing'
        }"
      >
        <mat-radio-button
          #existing
          value="existing"
          [disableRipple]="true"
          (click)="
            form.patchValue({ type: 'existing' });
            changeBackground(existing.value)
          "
        >
          <div class="font-efSans-primary font-semibold">
            <T
              str="Existing customer"
              key="customerPortal.kc.choose-existing.type.existing"
              tags="kc-forms, 3.1"
            ></T>
          </div>
        </mat-radio-button>
        <div class="font-efSans-primary text-sm whitespace-normal">
          <T
            str="Comparison with the existing data sets"
            key="customerPortal.kc.choose-existing.type.existing.text"
            tags="kc-forms, 3.1"
          ></T>
        </div>
      </div>
    </mat-radio-group>
    <input type="hidden" name="step" value="choose_existing" />
    <input
      type="hidden"
      name="existingCustomer"
      [value]="form.value.type === 'existing'"
    />
    <div class="mt-10">
      <button
        data-cy="registration-new-existing-customer-submit-button"
        mat-button
        mat-raised-button
        color="secondary"
        class="revolution float-right w-full md:w-1/2 button-spinner"
        (click)="submit()"
        [disabled]="!form.valid || submitting"
      >
        <customer-portal-ef-spinner
          [color]="'mat-ef-revolution-grey-two-500'"
          [opacity]="0.7"
          [diameter]="16"
          *ngIf="submitting"
        >
        </customer-portal-ef-spinner>
        {{ 'next' | sharedTranslate }}
      </button>
    </div>
  </form>
</div>
